'use client'

import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

export default async function goToProduct(
  router: AppRouterInstance,
  slug: string,
  searchParams?: URLSearchParams
) {
  const { push } = router
  const params =
    searchParams && searchParams.toString() ? `?${searchParams.toString()}` : ''
  push(`/p/${slug}${params}`)
}
